'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fast';
var iconName = 'explosion';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'e4e9';
var svgPathData = 'M55.6 355.4c56.4 8.1 85.8 12.3 88.4 12.6l-4.6-16.8c-28.5-104.4-42.9-157.5-43.4-159.2 .2 .2 43.6 38.8 130.2 115.7l13.8 12.3 3.8-18.1 36.2-173.9 16 0 35.3 162.2 4.7 21.8 12.3-18.5 164.9-247.3 30.8-46.2-16.2 53.1-90.7 298-5.1 16.9c2.8-.4 32.2-4.6 88.4-12.6L544 352c-2 2.3-28.6 34.4-80 96l-20.8 0 61.9-74.3c-54.9 7.8-86.8 12.4-95.7 13.7l7.3-24.1 80.4-264.1-147.8 221.6-20.9 31.4c-1.3-6-14.7-67.7-40.2-185l-32.5 156-5.6 27.1-20.7-18.4-103.8-92.2 33.8 124.1 6.4 23.5c-8.3-1.2-39.9-5.7-94.9-13.6l61.9 74.3-20.8 0c-51.4-61.7-78-93.6-80-96l23.6 3.4zM296 8l0 88-16 0 0-96 16 0 0 8zM8 496l184.3 0c4.1-49.3 45.3-88 95.7-88s91.6 38.7 95.7 88l192.3 0 0 16-576 0 0-16 8 0zm200.4 0l159.2 0c-4-40.4-38.1-72-79.6-72s-75.6 31.6-79.6 72z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faExplosion = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;